import AnimationClip from '../AnimationClip';
import { Tween, Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import OverlayComponent from '../../../Component/UI/Overlay';
import Interactable from '../../../Component/Interactable';

export class OverlayFadeOut extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const renderable: Renderable = gameObject.getComponent(Renderable);
        const overlay: OverlayComponent = gameObject.getComponent(
            OverlayComponent
        );

        renderable.alpha = 0.9;
        renderable.visible = true;

        const fadeOutTween: Tween = this.getTween(renderable);

        fadeOutTween.to({ alpha: 0 }, 500).easing(Easing.Linear.None);

        yield* this.startTween(fadeOutTween);

        renderable.visible = false;
        gameObject.getComponent(Interactable).enabled = false;
    }
}
